import { Routes } from '@angular/router';
import { adminGuard } from 'src/core/guards/admin.guard';
import { authGuard } from 'src/core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/tabs',
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('../pages/tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'payment/success',
    loadComponent: () =>
      import('../pages/payment-callback/payment-callback.page').then((m) => m.PaymentCallbackPage),
  },
  {
    path: 'payment/failed',
    loadComponent: () =>
      import('../pages/payment-callback/payment-callback.page').then(
        (m) => m.PaymentCallbackPage,
      ),
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    canActivateChild: [adminGuard],
    loadChildren: () =>
      import('../pages/admin/pages/admin-tabs/admin-tabs.routes').then(
        (m) => m.routes,
      ),
  },
  {
    path: '**',
    redirectTo: '/tabs',
  },
];
